module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-14-41.195Z.6d0de705.png";